import React from 'react';
import { FolderIcon } from '~/presentation/base/icons';

import { Container, Icon } from './styles/Styled';

interface ownProps {
  message?: string;
}

const ListEmpty: React.FC<ownProps> = ({ message }) => {
  return (
    <Container>
      <Icon>
        <FolderIcon />
      </Icon>
      <text>{message}</text>
    </Container>
  );
};
export default ListEmpty;
